export default __webpack_public_path__ + "static/media/lr.f3be2da8.jpg";